import React from 'react';
import { StepComponentProps } from '../types';
import WelcomeScreen from '../../welcome-screen';
import AiProspectEnrichmentOptions from '../../ai-prospect-enrichment-options';

const ChooseOption: React.FC<StepComponentProps> = ({
  handleMoveToNextStep,
  handleModalClose,
  show,
  showIntro,
  setShowIntro,
  stepData
}) => (
  <div
    className={`ai-columns-drawer-main-container ${
      showIntro ? 'intro' : 'expanded'
    }`}
  >
    {/* Welcome animation */}
    <WelcomeScreen
      show={show}
      showIntro={showIntro}
      setShowIntro={setShowIntro}
      handleModalClose={handleModalClose}
    />

    {/* Second Page */}
    <AiProspectEnrichmentOptions
      handleMoveToNextStep={handleMoveToNextStep}
      stepData={stepData}
    />
  </div>
);
export default ChooseOption;
